import React, { useEffect, useState } from 'react'
import { Box } from '@mui/material'
import HeroBanner from '../Components/HeroBanner'
import SearchExercies from '../Components/SearchExercies'
import Excercises from '../Components/Excercises'
import Bounce from 'react-reveal/Bounce';
import Slide from 'react-reveal/Slide';
import { exerciseOptions, fetchData } from '../utils/FetchData'
import Footer from '../Components/Footer'
function Home() {
  const [bodyPart, setBodyPart] = useState('all')
  const [exercises, setExercises] = useState([])

  useEffect((

  ) => {
    const getData = async () => {
      let exercisesData = [];
      if (bodyPart == "all") {
        exercisesData = await fetchData('https://exercisedb.p.rapidapi.com/exercises', exerciseOptions);

      }
      else
        exercisesData = await fetchData(`https://exercisedb.p.rapidapi.com/exercises/bodyPart/${bodyPart}`, exerciseOptions);
      setExercises(exercisesData);
    }
    getData();

  }, [bodyPart])




  return (
    <Box>
      <Bounce top> <HeroBanner /></Bounce>


      <Slide bottom>
        <SearchExercies setExercises={setExercises}
          bodyPart={bodyPart}
          setBodyPart={setBodyPart}
        />

      </Slide>
      <Excercises

        exercises={exercises}
        setExercises={setExercises}
        bodyPart={bodyPart}
      />
    </Box>
  )
}

export default Home